import React from "react";

export default function ColorWheelIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 671 672" fill="none">
      <path
        d="M606.907 138.372C627.412 166.561 643.633 198.062 654.622 231.929L335.49 335.679L606.907 138.372Z"
        fill="#41BC68"
      />
      <path
        d="M335.49 -0.000113915C371.683 -0.000113915 406.526 5.75719 439.183 16.3673L335.49 335.679V-0.000113915Z"
        fill="#3D5CB3"
      />
      <path
        d="M16.3582 439.43C5.75413 406.754 0 371.891 0 335.679H335.49L16.3582 439.43Z"
        fill="#88154F"
      />
      <path
        d="M231.798 16.3673C264.455 5.75719 299.298 -0.000113915 335.49 -0.000113915V335.679L231.798 16.3673Z"
        fill="#373C9C"
      />
      <path
        d="M532.686 64.1098C561.136 84.8269 586.201 109.906 606.907 138.372L335.49 335.679L532.686 64.1098Z"
        fill="#54C6C1"
      />
      <path
        d="M16.3584 231.929C27.3484 198.062 43.5693 166.561 64.0734 138.372L335.49 335.679L16.3584 231.929Z"
        fill="#452B8F"
      />
      <path
        d="M138.294 64.1098C166.467 43.5939 197.951 27.3638 231.798 16.3673L335.49 335.679L138.294 64.1098Z"
        fill="#312F8A"
      />
      <path
        d="M0 335.679C0 299.467 5.75413 264.604 16.3582 231.929L335.49 335.679H0Z"
        fill="#60237C"
      />
      <path
        d="M64.0732 138.372C84.7789 109.906 109.844 84.8269 138.294 64.1098L335.49 335.679L64.0732 138.372Z"
        fill="#382D8B"
      />
      <path
        d="M439.183 16.3673C473.03 27.3638 504.513 43.5939 532.686 64.1098L335.49 335.679L439.183 16.3673Z"
        fill="#5BB3E7"
      />
      <path
        d="M439.183 654.99C406.526 665.6 371.683 671.357 335.49 671.357V335.679L439.183 654.99Z"
        fill="#F79317"
      />
      <path
        d="M231.798 654.99C197.951 643.995 166.467 627.765 138.294 607.25L335.49 335.679L231.798 654.99Z"
        fill="#E42823"
      />
      <path
        d="M335.49 671.357C299.298 671.357 264.455 665.6 231.798 654.99L335.49 335.679V671.357Z"
        fill="#EF4D1C"
      />
      <path
        d="M335.49 335.679L64.0734 532.986C43.5693 504.798 27.3484 473.296 16.3584 439.43L335.49 335.679Z"
        fill="#AF1C26"
      />
      <path
        d="M654.622 231.929C665.226 264.604 670.98 299.467 670.98 335.679H335.49L654.622 231.929Z"
        fill="#46BB3A"
      />
      <path
        d="M138.294 607.25C109.844 586.532 84.7789 561.452 64.0732 532.985L335.49 335.679L138.294 607.25Z"
        fill="#CC1E25"
      />
      <path
        d="M654.622 439.43C643.633 473.296 627.412 504.798 606.907 532.986L335.49 335.679L654.622 439.43Z"
        fill="#D2E520"
      />
      <path
        d="M670.98 335.679C670.98 371.891 665.226 406.754 654.622 439.43L335.49 335.679H670.98Z"
        fill="#8CD024"
      />
      <path
        d="M532.686 607.25C504.513 627.765 473.03 643.995 439.183 654.99L335.49 335.679L532.686 607.25Z"
        fill="#FACA14"
      />
      <path
        d="M606.907 532.985C586.201 561.452 561.136 586.532 532.686 607.25L335.49 335.679L606.907 532.985Z"
        fill="#F6EF15"
      />
    </svg>
  );
}
